module.exports = __webpack_public_path__ + "static/media/connect-offroad.7cb9e867.png";